import { DateFormat, formatUtils } from '@kanbu/shared';
import { useLingui } from '@lingui/react/macro';

function formatDate(value?: string | null) {
  if (!value) return '—';
  const date = new Date(value);

  return Number.isNaN(date.getTime())
    ? '—'
    : formatUtils.date(date, DateFormat.DateTimeNumeric);
}

export function ContentUpdatedCell({
  contentUpdatedAt,
  createdAt,
  lastCheckedAt,
}: {
  contentUpdatedAt?: string | null;
  createdAt?: string | null;
  lastCheckedAt?: string | null;
}) {
  const { t } = useLingui();
  const checked = formatDate(lastCheckedAt);

  return (
    <span
      className='text-sm text-muted-fg'
      title={lastCheckedAt ? t`Last checked: ${checked}` : undefined}
    >
      {formatDate(contentUpdatedAt ?? createdAt)}
    </span>
  );
}
